import type { KidDetails } from '@ts-kids/interfaces'

import { useKidStore } from '@stores/kid'
import { useCommonStore } from '@stores/common'

import { useAdminRoutes } from '@composables/routes/admin-route.hook'

import { runApiGet } from '@utils/api/run-api-get'

interface KidDetailsApiOptions {
  kidId: string | number
  /** Defaults to the page loader; a modal that waits for the refresh passes its own. */
  onLoadingChange?: (loading: boolean) => void
}

/** `GET /admin-api/kids/{kid}/details` — the kid page: edit form, customer and disciplines with counters. */
export const useKidDetailsApi = async (options: KidDetailsApiOptions): Promise<KidDetails | null> => {
  const kidStore = useKidStore()
  const commonStore = useCommonStore()

  return runApiGet<KidDetails>(useAdminRoutes('admin.kid.details', { kid_id: options.kidId }), {
    setLoading: options.onLoadingChange ?? commonStore.setLoading,
    handle: (response) => {
      const kid: KidDetails = response.data
      kidStore.setKid(kid)
      return kid
    },
  })
}
